





















import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import Reservation from '@/modules/reservation/model/Reservation'
import {notify} from '@/modules/core/notification'

/**
 * Confirmación de eliminación de una reserva
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class DeleteReservationConfirm extends Vue {
    /**
     * Controla la visibilidad del componente
     */
    @Prop({type: Boolean, default: false})
    public active: boolean

    /**
     * Reserva actualmente seleccionada por el usuario, la cual será
     * eliminada
     */
    @State(state => state.reservation.currentReservation)
    public reservation: Reservation

    /**
     * Elimina la reserva actualmente seleccionada por el usuario
     */
    @Action('reservation/deleteReservation')
    public deleteReservation: () => void

    public deleting = false

    /**
     * Elimina la reserva actualmente seleccionada
     */
    public async remove () {
        this.deleting = true
        const id = this.reservation.id
        try {
            await this.deleteReservation()
            notify(`La reserva con id #${id} se ha eliminado correctamente`)
        } catch (e) {
            notify(`Error: ${e.message}`)
        }

        this.deleting = false
        this.$emit('update:active', false)
    }
}
